import type { TableName } from "../../common/database-strings";
import { memoizeFunction } from "../../common/memoize";
import { DefaultArrayMap } from "../../support/array-map";
import type { AppDescriptionContext } from ".";
import { areTableNamesEqual } from "../../common/description";
import type { SearchResult } from "./find-column-uses";
import { ColumnsUsedVisitor, SearchResultKind } from "./find-column-uses";
import { walkAppDescription } from "./walk-app-description";

class Visitor extends ColumnsUsedVisitor {
    private readonly uses = new DefaultArrayMap<TableName, Set<string>>(areTableNamesEqual, () => new Set());

    protected addColumnUsed(tn: TableName, cn: string, searchResult: SearchResult): void {
        if (searchResult.kind !== SearchResultKind.Component) return;
        if (searchResult.descriptorCase?.searchable !== true) return;

        this.uses.get(tn).add(cn);
    }

    public get columnsUsed(): ReadonlyMap<TableName, ReadonlySet<string>> {
        return this.uses;
    }
}

export const getSearchableColumns = memoizeFunction("getSearchableColumns", (adc: AppDescriptionContext) => {
    const visitor = new Visitor(adc);
    walkAppDescription(adc, visitor, false, false, false);
    return visitor.columnsUsed;
});
